var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopRecordPreviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0002 25.8002C16.395 25.8002 19.6507 24.4516 22.0512 22.0512C24.4516 19.6507 25.8002 16.395 25.8002 13.0002C25.8002 9.60542 24.4516 6.34969 22.0512 3.94923C19.6507 1.54876 16.395 0.200195 13.0002 0.200195C9.60542 0.200195 6.34969 1.54876 3.94923 3.94923C1.54876 6.34969 0.200195 9.60542 0.200195 13.0002C0.200195 16.395 1.54876 19.6507 3.94923 22.0512C6.34969 24.4516 9.60542 25.8002 13.0002 25.8002ZM9.8002 8.2002C9.37585 8.2002 8.96888 8.36877 8.66883 8.66883C8.36877 8.96888 8.2002 9.37585 8.2002 9.8002V16.2002C8.2002 16.6245 8.36877 17.0315 8.66883 17.3316C8.96888 17.6316 9.37585 17.8002 9.8002 17.8002H16.2002C16.6245 17.8002 17.0315 17.6316 17.3316 17.3316C17.6316 17.0315 17.8002 16.6245 17.8002 16.2002V9.8002C17.8002 9.37585 17.6316 8.96888 17.3316 8.66883C17.0315 8.36877 16.6245 8.2002 16.2002 8.2002H9.8002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopRecordPreviewIcon);
export default __webpack_public_path__ + "static/media/stopRecordPreviewIcon.6a69f0234c68d920ab06d22252a76161.svg";
export { ForwardRef as ReactComponent };